const common = require("lib/labels/_common");

// Home.backoffice.cards

module.exports = {
  groups: {
    title: common.groups,
    manage: common.manage
  },
  repos: {
    title: {
      en: "Repositories",
      fr: "Dépôts"
    },
    manage: common.manage
  },
  apis: {
    title: {
      en: "Pricing and functionalities",
      fr: "Prix et fonctionnalités"
    },
    manage: common.manage
  },
  licences: {
    title: {
      en: "Licences",
      fr: "Licences"
    },
    manage: common.manage
  },
  services: {
    title: {
      en: "Databases",
      fr: "Bases de données"
    },
    manage: common.manage
  },
  profiles: {
    title: {
      en: "Profiles",
      fr: "Profils"
    },
    manage: common.manage
  },
  users: {
    title: common.users,
    manage: common.manage
  },
  theme: {
    title: {
      en: "Theme",
      fr: "Thème"
    },
    manage: common.manage
  },
  apps: {
    title: common.apps,
    manage: common.manage
  },
  etat: {
    en: "Ready",
    fr: "Prêt"
  }
};
